export const tooltipPositions = {
  top: 'top',
  bottom: 'bottom',
  left: 'left',
  right: 'right',
}

export const getContentTransform = (position: keyof typeof tooltipPositions): string => {
  switch (position) {
    case 'top':
      return 'translate(-50%, -100%)'
    case 'bottom':
      return 'translate(-50%, 0%)'
    case 'left':
      return 'translate(-100%, -50%)'
    case 'right':
      return 'translate(0, -50%)'
    default:
      return 'translate(-50%, -100%)'
  }
}

export const getArrowTop = (position: keyof typeof tooltipPositions, offset: string): string => {
  if (position === 'bottom') return offset
  if (position === 'left' || position === 'right') return '50%'

  return 'auto'
}

export const getArrowBottom = (position: keyof typeof tooltipPositions, offset: string): string => {
  if (position === 'top') return offset

  return 'auto'
}

export const getArrowLeft = (position: keyof typeof tooltipPositions, offset: string): string => {
  if (position === 'top' || position === 'bottom') return '50%'
  if (position === 'right') return offset

  return 'auto'
}

export const getArrowRight = (position: keyof typeof tooltipPositions, offset: string): string => {
  if (position === 'left') return offset

  return 'auto'
}

export const getArrowMarginTop = (position: keyof typeof tooltipPositions, offset: string): string => {
  if (position === 'left' || position === 'right') return offset

  return 'auto'
}

export const getArrowMarginLeft = (position: keyof typeof tooltipPositions, offset: string): string => {
  if (position === 'top' || position === 'bottom') return offset

  return 'auto'
}
